module.exports = __webpack_public_path__ + "static/img/259_TO8_2327_og.7d243cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/259_TO8_2327_og.jpg
// module id = pSO3
// module chunks = 0